/**************************************************
 * Nombre:       Tarjeta_Sub_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";

const Tarjeta_Sub_Categorias = ({item}) => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderBottom: 1,
                borderColor: '#00000080',
            }}
        >

            <Grid2 container size={12} sx={{justifyContent: 'flex-start'}}>
                <Typography>{item.nombre}</Typography>
            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Sub_Categorias